
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class LoaderService {
    private counter: number = 0;
    private isNewShopVersion: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    isLoading = new BehaviorSubject<boolean>(false);

    show() {
        this.counter++;
        this.isLoading.next(true);
    }

    hide() {
        this.counter--;
        if (this.counter < 1) this.isLoading.next(false);
    }

    getIsNewShopVersion() {
        return this.isNewShopVersion.asObservable();
    }
    
  setIsNewShopVersion(status: boolean): void {
    if (this.isNewShopVersion.value !== status) {
      this.isNewShopVersion.next(status);
    }
  }
}
